import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const useRedirectToNotEmptyPage = ({
    activePage,
    itemsPerPageCount,
    total,
    isAnotherPage,
}: {
    activePage: number;
    itemsPerPageCount: number;
    total: number;
    isAnotherPage?: boolean;
}) => {
    const { query, push } = useRouter();

    useEffect(() => {
        if (total > 0 && activePage * itemsPerPageCount - total > itemsPerPageCount) {
            push({
                query: {
                    ...query,
                    ...(isAnotherPage
                        ? { page_another: Math.ceil(total / itemsPerPageCount) }
                        : { page: Math.ceil(total / itemsPerPageCount) }),
                },
            });
        }
    }, [total]);
};
